import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "../../../styles";
import { Box, Tooltip, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { DEFAULT_ROUTE } from "utils/constants";
import { truncateString } from "utils/helpers";
import { RelatedOrder } from "../../../types";

type Props = {
  relatedOrders: RelatedOrder[],
}

export const OrderListComponent: FC<Props> = ({ relatedOrders }) => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <Box className={classes.relatedOrdersListContainer}>
      {relatedOrders.map(({ address, orders }) => (
        <Box
          key={address}
          className={classes.relatedOrdersitem}
        >
          <Typography
            className={classes.relatedOrdersItemText}
            title={address}
          >
            {truncateString(address, 50)}
          </Typography>
          <Box className={classes.relatedOrdersListItemContainer}>
            {orders.map((order, index) => (
              <Tooltip key={order._id} title={t('common:view-order')}>
                <Link to={`/orders/details/${order._id}/${DEFAULT_ROUTE}`} style={{ textDecoration: "none" }}>
                  <Typography
                    className={index + 1 === orders.length
                      ? classes.relatedOrdersItemOrderNumber
                      : `${classes.relatedOrdersItemOrderNumber} ${classes.relatedOrdersItemOrderNumberDivided}`}
                  >
                    {order.order_id}
                  </Typography>
                </Link>
              </Tooltip>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export const OrderList = OrderListComponent;
